import styled from 'styled-components'

export const Body = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const Table = styled.table(({ theme }) => ({
  '& tbody tr': {
    borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray300}`,
  },

  '& td': {
    padding: `${theme.space['12']} ${theme.space['0']}`,
    verticalAlign: 'middle',
  },

  '& td:first-child, & th:first-child': {
    width: '100%',
  },

  '& th': {
    padding: `${theme.space['12']} ${theme.space['0']}`,
    verticalAlign: 'middle',
  },

  '& thead tr': {
    borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray300}`,
  },

  borderCollapse: 'collapse',
  width: '100%',
}))

export const TableHead = styled.thead(() => ({}))

export const SwitchCell = styled.td(({ theme }) => ({
  display: 'flex',
  gap: theme.space['10'],
}))

export const SwitchContainer = styled.div(() => ({
  display: 'flex',
  flexShrink: 0,
  width: '10rem',
}))
